/** Цифры российского номера: 7 + 10 цифр (без +). */
export function normalizeRuPhoneDigits(raw: string): string {
  let digits = raw.replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("8")) digits = `7${digits.slice(1)}`;
  if (!digits.startsWith("7")) digits = `7${digits}`;
  return digits.slice(0, 11);
}

/** Маска ввода: +7 (958) 100-94-58 */
export function formatRuPhoneInput(raw: string): string {
  const digits = normalizeRuPhoneDigits(raw);
  if (!digits) return "";

  const local = digits.slice(1);
  const a = local.slice(0, 3);
  const b = local.slice(3, 6);
  const c = local.slice(6, 8);
  const d = local.slice(8, 10);

  let out = "+7";
  if (a) out += ` (${a}`;
  if (a.length === 3) out += ")";
  if (b) out += ` ${b}`;
  if (c) out += `-${c}`;
  if (d) out += `-${d}`;
  return out;
}

export function ruPhoneToE164(display: string): string | null {
  const digits = normalizeRuPhoneDigits(display);
  if (digits.length !== 11) return null;
  return `+${digits}`;
}

export function isCompleteRuPhone(display: string): boolean {
  return ruPhoneToE164(display) !== null;
}

export function ruPhoneValidationError(
  display: string,
  options?: { required?: boolean },
): string | null {
  const trimmed = display.trim();
  if (!trimmed) {
    return options?.required ? "Укажите номер телефона" : null;
  }
  if (!isCompleteRuPhone(trimmed)) {
    return "Введите номер полностью: +7 (XXX) XXX-XX-XX";
  }
  return null;
}

/** E.164 (+79…) → маска +7 (XXX) XXX-XX-XX для отображения в формах. */
export function e164ToRuPhoneDisplay(e164: string | null | undefined): string {
  if (!e164?.trim()) return "";
  const digits = e164.replace(/\D/g, "");
  if (digits.length === 11) return formatRuPhoneInput(digits);
  return e164;
}
